import * as React from "react";

export const MascotSmall2 = (props: any) => (
  <svg
    width={52}
    height={52}
    viewBox="4 4 44 44"
    fill="#E48A99"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <path
        d="M26 48c12.15 0 22-9.85 22-22S38.15 4 26 4 4 13.85 4 26s9.85 22 22 22Z"
        fill="#fff"
      />
      <path
        d="M26 48c12.15 0 22-9.85 22-22S38.15 4 26 4 4 13.85 4 26s9.85 22 22 22Z"
        opacity={0.15}
      />
      <path d="M34.64 35.98a.96.96 0 0 1 .403.542.923.923 0 0 1-.063.663.98.98 0 0 1-.498.464 1.034 1.034 0 0 1-.692.04l-5.954-1.636a.79.79 0 0 1-.433-.155.742.742 0 0 1-.263-.365c-.047-.32.332-.754.93-.743v-6.807a9.39 9.39 0 0 1-3.79.016v9.839l3.092 1.41a.96.96 0 0 1 .404.544.924.924 0 0 1-.063.663.98.98 0 0 1-.499.464 1.034 1.034 0 0 1-.692.039l-5.952-1.635a.791.791 0 0 1-.433-.155.743.743 0 0 1-.263-.365c-.047-.321.332-.754.93-.743V26.49a8.612 8.612 0 0 1-3.19-4.296 8.274 8.274 0 0 1 .024-5.277 8.62 8.62 0 0 1 3.23-4.268A9.189 9.189 0 0 1 26.083 11a9.195 9.195 0 0 1 5.237 1.592 8.63 8.63 0 0 1 3.28 4.233 8.274 8.274 0 0 1 .087 5.277 8.601 8.601 0 0 1-3.138 4.33v8.133l3.09 1.415Zm-1.555-19.572-.166-.897-.698-.671-8.21-.463-.69.538-.297 1.018 3.714 7.036.852.306 1.012-.258 4.483-6.609Z" />
      <path d="M28.065 19.93c1.196 0 2.165-.93 2.165-2.08 0-1.148-.97-2.08-2.165-2.08s-2.165.932-2.165 2.08c0 1.15.97 2.08 2.165 2.08Z" />
    </g>
    <defs>
      <filter
        id="a"
        x={0}
        y={0}
        width={52}
        height={52}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.362353 0 0 0 0 0.418353 0 0 0 0 0.54902 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_74_24546"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_74_24546"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
